export enum MenuItems {
    NONE = 0,
    CLASSIFICATION,
    REVISION,
    JOURNALIST,
    VEHICLE,
    USER,
    CLIENT,
    CLIPPER,
    SOCIAL_MEDIA,
    DASHBOARD,
    INFLUENCER,
    INFLUENCER_SUBMIT,
    INFLUENCER_ClASSIFICATION,
    INFLUENCER_CONSULT,
    CAMPAIGN,
    COMPANY,
}